import axios from 'axios'
const prefix = 'admin'
import Vue from 'vue'

async function get (url, params = {}) {
  let allData
  let token = window.localStorage.getItem('token')
  let headers = token ? {'Token': token} : {}
  try {
    let {data} = await axios.get(url, {params, headers}, )
    // Vue.$route.replace('index')
    allData = data
  } catch (e) {
    allData = { success: false, info: '网络错误' }
  }
  let {authentication} = allData
  if ('authentication' in allData && !authentication) {
    window.localStorage.removeItem('l1')
    window.location.replace('/')
    // Vue.$router.replace('index')
  }
  return allData
}
async function getImg (url, params = {}) {
  let res
  try {
    res = await axios({
      url,
      method: 'get',
      responseType: 'arraybuffer'
    })
  } catch (e) {
    res = { success: false, info: '网络错误' }
    return res
  }
  if (res.status === 200) {
    let base64 = window.btoa(String.fromCharCode(...new Uint8Array(res.data)))
    base64 = 'data:image/png;base64,' + base64
    return {success: true, data: base64}
  } else {
    return { success: false, info: '请求错误' }
  }
  // console.log(data)
  // .then(res => {
  //   let base64 = window.btoa(String.fromCharCode(...new Uint8Array(res.data)))
  //   base64 = 'data:image/png;base64,' + base64
  //   this.src = base64
  // })
}
async function post (url, params) {
  let allData
  let formData = new window.FormData()
  for (let key in params) {
    let value = params[key]
    // if (value === 0) value = '0'
    // if (!value) continue
    if (typeof (value) === 'object') {
      for (let i in value) {
        formData.append(key + '[]', value[i])
      }
    } else {
      formData.append(key, value)
    }
  }
  let token = window.localStorage.getItem('token')
  console.log(token, '!!!!!!!!!')
  let headers = {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
  if (token) {
    headers['Token'] = token
  }
  // formData.append('Sign', sign(params))
  try {
    let {data} = await axios.post(url, formData, {headers})
    allData = data
  } catch (e) {
    allData = { success: false, info: '网络错误' }
  }
  let {authentication} = allData
  if ('authentication' in allData && !authentication) {
    window.localStorage.setItem('l1')
    window.location.replace('/')
    // Vue.$router.replace('index')
  }
  return allData
}

async function postFile (url, formData) {
  let allData
  let token = window.localStorage.getItem('token')
  let headers = token ? {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Token': token} : {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
  // formData.append('Sign', sign(params))
  try {
    let {data} = await axios.post(url, formData, {headers})
    allData = data
  } catch (e) {
    allData = { success: false, info: '网络错误' }
  }
  let {authentication} = allData
  if ('authentication' in allData && !authentication) {
    window.localStorage.setItem('l1')
    window.location.replace('/')
    // Vue.$router.replace('index')
  }
  return allData
}

async function del (url, params = {}) {
  let allData
  try {
    let {data} = await axios.delete(url, {params})
    allData = data
  } catch (e) {
    allData = { success: false, info: '网络错误' }
  }
  return allData
}
// async function getFile (url, params = {}, filename = '') {
//   axios({
//     url,
//     method: 'post',
//     params,
//     responseType: 'blob'
//   }).then(res => {
//     /* 兼容ie内核，360浏览器的兼容模式 */
//     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
//       let blob = new Blob([res.data])
//       window.navigator.msSaveOrOpenBlob(blob, filename)
//     } else {
//     /* 火狐谷歌的文件下载方式 */
//       var blob = new Blob([res.data])
//       var downloadElement = document.createElement('a')
//       var href = window.URL.createObjectURL(blob)
//       downloadElement.href = href
//       downloadElement.download = filename
//       document.body.appendChild(downloadElement)
//       downloadElement.click()
//       document.body.removeChild(downloadElement)
//       window.URL.revokeObjectURL(href)
//     }
//   }).catch(res => {
//     console.log(res)
//   })
// }

export default {
  login (params = {}) {
    return post(prefix + '/Login/Insert', params)
  },
  getUserInfo () { // 获取登录信息详情
    return get(prefix + '/Login/GetLoginInfo')
  },
  HelpUserGet () {// 获取救助人员信息详情
    return get(prefix + '/HelpUser/Get')
  },
  HelpTypeGetList (params) { // 获取救助分类
    return get(prefix + '/HelpType/GetList', params)
  },
  StreetOfficeGetList (params) { // 获取街道列表
    return get(prefix + '/StreetOffice/GetList', params)
  },
  ClientGet (params) {
    return get(prefix + '/HelpUser/Get', params)
  },
  HelpUserGetList (params) { // 工作人员端分页获取人员信息
    return get(prefix + '/HelpUser/GetList', params)
  },
  HelpUserGetAudiDetailList  (params) { // 获取年审记录
    console.log(params)
    return get(prefix + '/HelpUser/GetAudiDetailList', params)
  },
  userAudit (params = {}) {
    return postFile(prefix + '/HelpUser/Audit', params)
  },
  CheckCanUserAudit (params = {}) { // 检查救助对象是否能进行年审
    return post(prefix + '/HelpUser/CheckCanUserAudit', params)
  },
  LivePersonCheckV2 (params = {}) {
    return postFile(prefix + '/Home/LivePersonCheckV2', params)
  },
  ReportGetWorkerViewList (params = {}) {
    return get(prefix + '/Report/GetWorkerViewList', params)
  }
}
